(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("2meyv", function(module, exports) {

var $1CRso = parcelRequire("1CRso");
const $1b78ed481bf862d4$var$reInitializations = ()=>{
    document.dispatchEvent(new Event("baseformReinit"));
    document.dispatchEvent(new Event("postsReinit"));
    document.dispatchEvent(new Event("lazyloadReinit"));
    document.dispatchEvent(new Event("cursorInit"));
};
document.querySelectorAll(".s-posts-list").forEach((section)=>{
    const buttonLoad = section.querySelector(".--js-load-more");
    const buttonsGroup = section.querySelector(".s-posts-list__buttons");
    const postsGroup = section.querySelector(".g-posts");
    const getCategory = ()=>{
        return section.querySelector(".s-posts-list__tags.--categories .i-tag__input:checked, .s-posts-list__category-input")?.value;
    };
    const getHastag = ()=>{
        return section.querySelector(".s-posts-list__tags.--hashtags .i-tag__input:checked, .s-posts-list__hastag-input")?.value;
    };
    const getAuthor = ()=>section.querySelector(".s-posts-list__author-input")?.value;
    const getSearchQuery = ()=>section.querySelector(".s-posts-list__search-query-input")?.value;
    const getLimit = ()=>section.querySelector(".s-posts-list__limit-input")?.value;
    const getNewsletter = ()=>section.querySelector(".s-posts-list__newsletter-input")?.value;
    const getPage = ()=>Number(buttonLoad?.dataset.page ?? 2);
    const getParameters = (page)=>{
        const parameters = {
            page: page,
            limit: getLimit() ? Number(getLimit()) : undefined,
            category: getCategory(),
            author: getAuthor(),
            search: getSearchQuery(),
            hashtag: getHastag(),
            newsletter: getNewsletter()
        };
        return parameters;
    };
    const addLoading = ()=>{
        postsGroup?.classList.add("--loading");
        buttonsGroup?.classList.add("--loading");
    };
    const removeLoading = ()=>{
        postsGroup?.classList.remove("--loading");
        buttonsGroup?.classList.remove("--loading");
    };
    // Load more handle
    buttonLoad?.addEventListener("click", async ()=>{
        addLoading();
        const currentPage = getPage();
        const data = await (0, $1CRso.postsClient).list(getParameters(currentPage));
        if (!data) {
            removeLoading();
            return;
        }
        postsGroup?.insertAdjacentHTML("beforeend", data.items); // Add to items to group
        buttonLoad.dataset.page = String(currentPage + 1);
        buttonsGroup?.classList.toggle("d-none", !data.isLoadMore); // Show loadmore if is more to load
        $1b78ed481bf862d4$var$reInitializations();
        removeLoading();
    });
    // Filtration handle
    section.querySelectorAll(".i-tag.--input .i-tag__input").forEach((input)=>{
        input.addEventListener("change", async ()=>{
            addLoading();
            const data = await (0, $1CRso.postsClient).list(getParameters(1));
            if (!data) {
                removeLoading();
                return;
            }
            if (postsGroup) postsGroup.innerHTML = data.items;
            $1b78ed481bf862d4$var$reInitializations();
            buttonsGroup?.classList.toggle("d-none", !data.isLoadMore);
            if (buttonLoad) buttonLoad.dataset.page = String(2);
            removeLoading();
        });
    });
});

});
parcelRegister("1CRso", function(module, exports) {

$parcel$export(module.exports, "postsClient", function () { return $12f2ce7d4c1e1d45$export$41c14754c6ad45c0; });
class $12f2ce7d4c1e1d45$var$PostsClient {
    responseSettings = {
        method: "GET"
    };
    async list(parameters) {
        console.log(parameters);
        const urlBase = "/api/article/list";
        const url = new URL(`${window.location.origin}${urlBase}`);
        for (const [key, value] of Object.entries(parameters))if (value) url.searchParams.append(key, String(value));
        const response = await fetch(url.toString(), this.responseSettings);
        console.log(response);
        if (!response.ok) return null;
        const data = await response.json();
        console.log(data);
        return data;
    }
}
const $12f2ce7d4c1e1d45$export$41c14754c6ad45c0 = new $12f2ce7d4c1e1d45$var$PostsClient();

});


})();
//# sourceMappingURL=posts-list.d60c3093.js.map
